import gql from 'graphql-tag'

export default gql`mutation pcpMessageConfirm($message_id: ID, $visit_id: ID) {
	pcpMessageConfirm(message_id: $message_id, visit_id: $visit_id) {
		status
  }
}`
